import React from 'react';

import FavoritedContentContext, {
  FavoritedContentContextValues
} from '@smart-tv/contexts/favorited-content-context/favorited-content-context';

export const useFavoritedContent = (): FavoritedContentContextValues => {
  const values = React.useContext(FavoritedContentContext);

  return { ...values };
};

export default useFavoritedContent;
